var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4617 1.24916C5.37376 1.24916 1.24916 5.37376 1.24916 10.4617C1.24916 15.5497 5.37376 19.6743 10.4617 19.6743C10.8067 19.6743 11.0863 19.9539 11.0863 20.2989C11.0863 20.6438 10.8067 20.9234 10.4617 20.9234C4.68387 20.9234 0 16.2396 0 10.4617C0 4.68387 4.68387 0 10.4617 0C16.2396 0 20.9234 4.68387 20.9234 10.4617C20.9234 10.8067 20.6438 11.0863 20.2989 11.0863C19.9539 11.0863 19.6743 10.8067 19.6743 10.4617C19.6743 5.37376 15.5497 1.24916 10.4617 1.24916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0352 13.136H20.9986V21.0994H13.0352V13.136ZM13.8159 13.9167V20.3187H20.2178V13.9167H13.8159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6717 15.711H14.7773V14.9302H15.6717V15.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4654 15.711H16.5664V14.9302H17.4654V15.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2615 15.711H18.3672V14.9302H19.2615V15.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6717 17.5097H14.7773V16.7289H15.6717V17.5097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4654 17.5097H16.5664V16.7289H17.4654V17.5097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2615 17.5097H18.3672V16.7289H19.2615V17.5097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6717 19.3021H14.7773V18.5214H15.6717V19.3021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4654 19.3021H16.5664V18.5214H17.4654V19.3021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6089 12.1791V13.9725H14.8281V12.1791H15.6089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1987 12.1791V13.9725H18.418V12.1791H19.1987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4664 3.12297C10.7251 3.12297 10.9349 3.3327 10.9349 3.59141V10.6558L7.83092 13.7598C7.64798 13.9427 7.35139 13.9427 7.16845 13.7598C6.98552 13.5768 6.98552 13.2802 7.16845 13.0973L9.99801 10.2678V3.59141C9.99801 3.3327 10.2077 3.12297 10.4664 3.12297Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.ac6eeffad00ccb3f8ae745f979ad5988.svg";
export { ForwardRef as ReactComponent };